import type { RowData, Table, TableMeta } from '@tanstack/react-table';

export type DataTableMeta<TData extends RowData> = TableMeta<TData> & {
  getSerialNumber?: (rowIndex: number) => number;
  loading?: boolean;
};

export function getSerialNumber<TData extends RowData>(table: Table<TData>, rowIndex: number) {
  const meta = table.options.meta as DataTableMeta<TData> | undefined;
  return meta?.getSerialNumber?.(rowIndex) ?? rowIndex + 1;
}

export function sanitizeTableSearch(value: string) {
  return value;
}

export function decodeTableSearch(value: string) {
  if (!value) return value;

  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch {
    return value.replace(/\+/g, ' ');
  }
}
